export const SAVE = 'step6.SAVE';
export const VALUE_CHANGED = 'step6.VALUE_CHANGED';
export const LOAD = 'step6.VALUE_LOAD';
export const NEXT = 'step6.NEXT';
export const RESET = 'step6.RESET';
export const RESET_TRAVEL_DELAY = 'step6.RESET_TRAVEL_DELAY';
export const RESET_CANCELLATION_AMENDMENT = 'step6.RESET_CANCELLATION_AMENDMENT';
export const RESET_COMPENSATION = 'step6.RESET_COMPENSATION';
export const RESET_ADDITIONAL = 'step6.RESET_ADDITIONAL';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step6/constants.js